import { useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useApiMutation } from '@/api/hooks/useMutation';
import { campaignKeys } from '@/api/queryKeys';

type Request = { campaignId: number; casProductId: number };

export function useUnreserveProduct() {
  const queryClient = useQueryClient();

  return useApiMutation<void, AxiosError, Request>({
    mutationFn:
      (api) =>
      async ({ campaignId, casProductId }) => {
        await api.campaigns.campaignsControllerUnreserveProduct(campaignId, casProductId);
      },
    onSuccess: async (_data, { campaignId }) => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: campaignKeys.detail(campaignId) }),
        queryClient.invalidateQueries({ queryKey: campaignKeys.lists() }),
      ]);
    },
  });
}
